<span
    class="flex h-full w-full items-center justify-center bg-primary-600 font-semibold text-white"
    aria-hidden="true"
>
    <!-- Trimmed to the capitals, so the initials sit in the true middle of the circle. -->
    <span class="[text-box:trim-both_cap_alphabetic]">{{ initials() }}</span>
</span>
